import type { AdminDashboardData } from '@workspace/api-backend'
import { TimeSeriesChart } from '@workspace/ui/components/time-series-chart'
import { BreakdownList } from './breakdown-list'
import { DashboardCard, DashboardSection } from './dashboard-card'
import { FunnelList } from './funnel-list'

export function OutreachSection({ data }: { data: AdminDashboardData }) {
  const { outreach } = data
  return (
    <DashboardSection title="Outreach">
      <div className="grid gap-4 lg:grid-cols-2">
        <DashboardCard title="Outreach activity per day" subtitle="LinkedIn campaign events">
          <TimeSeriesChart
            data={outreach.byDay}
            series={[
              { key: 'pushed', label: 'Messages pushed', color: 'var(--chart-1)' },
              { key: 'accepted', label: 'Connections accepted', color: 'var(--chart-2)' },
              { key: 'replied', label: 'Replies', color: 'var(--chart-4)', kind: 'line' },
            ]}
          />
        </DashboardCard>
        <DashboardCard title="Lead funnel">
          <FunnelList stages={outreach.leadFunnel} />
        </DashboardCard>
      </div>
      <DashboardCard
        title="Campaigns by status"
        subtitle="All startup outreach campaigns (current)"
      >
        <BreakdownList
          items={outreach.campaignsByStatus.map((s) => ({ label: s.status, count: s.count }))}
        />
      </DashboardCard>
    </DashboardSection>
  )
}
